import {Component, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {ValidationService} from '../validation.service';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl, FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR, ValidationErrors,
  Validator
} from '@angular/forms';
import {Calendar} from "primeng/calendar";
import * as moment from "moment-mini-ts";
import {environment} from "../../../../environments/environment";
import detectMobile from "../../../utils/detect-mobile";

@Component({
  selector: 'app-date-field',
  styleUrls: ['./date-field.component.sass'],
  templateUrl: './date-field.component.html',
})
export class DateFieldComponent {

  @Input() fieldName: string;
  @Input() formGroup: FormGroup;
  @Input() placeholder: string;
  @Input() disableRequiredIdentifier: boolean = false;
  @Input() disableRequiredIdentifierLabel: boolean = false;

  public brand;
  public isMobile;

  constructor() {
    this.brand = environment.brand;
    this.isMobile = detectMobile();
  }

  public get control() {
    return this.formGroup.get(this.fieldName) as FormControl;
  }

  public validation() {
    return ValidationService.getValidationClass(
      this.formGroup.get(this.fieldName) as FormControl, this.brand, this.disableRequiredIdentifier
    );
  }

  public valid() {
    return ValidationService.getValidationClassDate(
      this.formGroup.get(this.fieldName) as FormControl
    );
  }

  public formatFieldName(title) {
    return  this.isMobile && this.disableRequiredIdentifierLabel ? title + '*' : title
  }
}
